import { Link as RouterLink } from 'react-router-dom'
import type { LinkProps } from 'react-router-dom'
import { useLocale } from 'src/hooks/use-locale'

type CustomLinkProps = Omit<LinkProps, 'to'> & {
  href?: string
  to?: LinkProps['to']
}

export const Link = ({ href, to, ...props }: CustomLinkProps) => {
  const { locale } = useLocale()

  const raw = (to as string) || href || ''
  const localizedTo =
    typeof raw === 'string' && raw.startsWith('/') && !raw.match(/^\/(fr|en)\//)
      ? `/${locale}${raw}`
      : raw

  return <RouterLink {...props} to={localizedTo} />
}

export default Link
